











































import { confirmDelete } from '@/libs/decorator';
import MenuMixin from '@/mixins/menu-mixin';
import AnalyzeCustomServices, { AnalyzeCustomDto } from '@/services/analyzeCustom';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class BoardList extends mixins(MenuMixin) {
  @Prop() boardList!: any;
  @Prop() hasAdd!: boolean;

  add() {
    this.$emit('add');
  }

  customSrv = new AnalyzeCustomServices();

  toEdit(board: AnalyzeCustomDto) {
    this.$router.push('/analyze/custom/edit?code=' + board.boardCode);
  }

  @confirmDelete()
  async remove(board: AnalyzeCustomDto) {
    let res = await this.customSrv.remove(board.id || 0);
    if (!res) return false;
    this.$message.success('操作成功');
    this.$emit('reload');
  }
}
